import styled from "styled-components";

// Container styles
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    @media screen and (max-width: 480px) {
        width: 100%;
    }
`;

export const MainLayout = styled.div`
    display: grid;
    grid-template-columns: ${props => props.$hasSidebar ? "5fr 2fr" : "1fr"};
    gap: 26px;
    min-width: 100%;
    @media screen and (max-width: 1300px){
      grid-template-columns: ${props => props.$hasSidebar ? "5fr 3fr" : "1fr"};
      }
    @media screen and (max-width: 1210px) {
        grid-template-columns: 1fr;
        gap: 16px;
    }
`;

export const MainContent = styled.div`
    min-width: 0;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow: hidden;

    @media screen and (max-width: 1210px) {
        order: 2;
    }
`;
export const ModuleWrapper = styled.div`
    min-width: 0;
    max-width: 100%;
    gap: 10px;
    overflow: hidden;
`

export const Sidebar = styled.div`
    align-self: start;
    position: sticky;
    top: 20px;
      @media screen and (max-width: 1210px) {
        height: fit-content;
        position: static!important;
        max-width: 100%;
    }
`;

// Section styles
export const SectionTitle = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: var(--lightGray3);
    color: var(--lightGray3);
    margin-bottom: 4px;
    display: flex;
    align-items: center;
`;

export const SectionDescription = styled.div`
    font-size: 14px;
    color: var(--lightGray3);
    margin-bottom: 16px;
    line-height: 1.5;
`;

// Year accordion styles
export const YearGroup = styled.div`
    margin-bottom: 10px;
    box-shadow: 0px 2px 2.97px 0.03px var(--boxShadow);
    box-shadow: 0px 2px 2.97px 0.03px var(--boxShadow);
    border-radius: 2px;
    overflow: hidden;
`;

export const YearAccordionHeader = styled.div`
    background-color: var(--topbar-color);
    border-radius: ${props => props.$collapsed ? "2px" : "2px 2px 0 0"};
    padding: 10px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    height: 40px;
    box-sizing: border-box;
`;

export const YearAccordionTitle = styled.span`
    color: var(--white);
    font-size: 14px;
    font-weight: bold;
`;

export const YearAccordionRight = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    color: var(--white);
    font-size: 14px;
`;

export const CompletedText = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

// Module row styles
export const ModuleRow = styled.div`
        background-color: ${props =>
        props.$muted
            ? "var(--white2)"
            : props.$isExpanded
                ? "var(--white2)"
                : "var(--white)"};
    border: 1px solid var(--lightBlue);
    border-top: ${props => props.$isFirst ? "1px solid var(--lightBlue)" : "none"};
    border-radius: ${props => props.$isLast ? "0 0 2px 2px" : "0"};
    overflow: hidden;
    padding: 10px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    min-height: 40px;
    box-sizing: border-box;
    cursor: ${props => props.$hasDropdown ? "pointer" : "default"};
    transition: background-color 0.2s ease;

    ${props => {
        if (!props.$hasDropdown) return '';
        const hoverColor = props.$isExpanded ? "var(--whiteGrey)" : "var(--white2)";
        return `
            &:hover {
                background-color: ${hoverColor};
            }
        `;
    }};

    @media screen and (max-width: 480px) {
        flex-wrap: wrap;
        flex-direction: column;
        align-items: stretch;
       gap: 5px;
    }
`;

export const ModuleLeft = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
  
    @media screen and (max-width: 480px) {
        width: 100%;
        justify-content: space-between;
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
    }
`;

export const ModuleIcon = styled.div`
    width: 18px;
    display: flex;
    justify-content: center;
    flex-shrink: 0;
`;

export const ModuleName = styled.span`
    font-size: 14px;
    font-weight: 700;
    color: var(--link-color);
    text-box-edge: cap alphabetic;
    text-box-trim: trim-both;
    white-space: nowrap;
   text-wrap: pretty;


    flex: 1;
    min-width: 0;

    @media screen and (max-width: 480px) {
        font-size: 13px;
        white-space: normal;
        word-break: break-word;
            max-width: 150px;
    }
`;

export const ModuleRight = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 1;

    @media screen and (max-width: 480px) {
        width: 100%;
        justify-content: space-between;
        flex-wrap: nowrap;
        gap: 5x;
        width: 100%;
        margin-top: 8px;
    }
`;

export const ModuleSemester = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 14px;
    color: var(--lightGray3);
    text-box-edge: cap alphabetic;
    text-box-trim: trim-both;
    white-space: nowrap;
        @media screen and (max-width: 480px) {
   white-space: wrap;
   font-size: 12px;
    }
`;

export const ModulePrice = styled.span`
    font-size: 14px;
    font-weight: 700;
    color: ${props => props.$isCredit ? "var(--green)" : "var(--black1)"};
    min-width: 80px;
    text-align: right;
    text-box-edge: cap alphabetic;
    text-box-trim: trim-both;
    white-space: nowrap;
    visibility: ${props => props.$hidden ? "hidden" : "visible"};

    @media screen and (max-width: 480px) {
    margin-left: 10px;   
        text-align: left;
    }
`;

export const ModuleActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
  

    @media screen and (max-width: 480px) {
        gap: 6px;
    }
`;

export const ActionButton = styled.button`
    margin-left: 1em;
    min-width: 30px;
    width: 30px;
    height: 30px;
    max-height: 30px;
    border-radius: 50%;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    font-size: 14px;
    box-shadow: 0px 1.5px 2px 0px rgb(0 0 0 / 30%) !important;
    border: none !important;
    cursor: ${props => props.$disabled ? "not-allowed" : "pointer"};
    background-color: ${props => {
        if (props.$disabled) return "#cfd3d9";
        if (props.$variant === "delete") return "#dc3545";
        if (props.$variant === "add") return "var(--button-color)";
        return "#467fcf";
    }};

    color: var(--white);
    
    &:hover {
        background-color: var(--button-hover-color) !important;
    }
    
    i {
        margin-right: 0;
    }
`;

// Spacer used when an action button should be visually present but inactive (e.g. non-removable NOT ELIGIBLE modules)
export const ActionButtonSpacer = styled.div`
    margin-left: 1em;
    min-width: 30px;
    width: 30px;
    height: 30px;
    max-height: 30px;
    border-radius: 50%;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;
`;

export const ChevronButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 20px;
    color: var(--button-color);
    padding: 0 4px;
`;

// Module expanded styles
export const ModuleExpanded = styled.div`
    background-color:var(--white);
    border: 1px solid var(--lightBlue);
    border-top: none;
    padding: 12px ;

`;

export const ModuleDescription = styled.div`
    font-size: 14px;
      text-box-edge: cap alphabetic;
text-box-trim: trim-both;
    color: var(--lightGray3);
    text-wrap: pretty;
    line-height: 1.15;
 
`;

// Prerequisites styles
export const PrerequisitesTitle = styled.div`
    font-size: 14px;
    line-height: 1;
    font-weight: bold;
    color: var(--black1);
    margin: 12px 0 5px 0;
`;

export const PrerequisitesContainer = styled.div`
    border: 1px solid var(--lightBlue);
   
    border-radius: 2px;
    overflow: hidden;
`;
export const PrerequisiteWrapper = styled.div`

`

export const PrerequisiteRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 15px;
    background-color: ${props => props.$isFailed ? "#fff8f8" : "var(--white)"};
    border-bottom: ${props => props.$isLast ? "none" : "1px solid var(--lightBlue)"};
    min-height: 45px;
       @media screen and (max-width: 768px) {
        gap: 6px;
    }
`;

export const PrerequisiteLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    flex: 1;
`;

export const PrerequisiteName = styled.span`
    font-size: 14px;
    font-weight: 700;
    color: var(--link-color);
`;

export const PrerequisiteRight = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
       @media screen and (max-width: 768px) {
        gap: 6px;
    }
`;

// Submission container
export const SubmissionContainer = styled.div`
    border-radius: 2px;
    border: 1px solid var(--lightBlue);
    padding: 0px 20px 20px;
    border-radius: 2px;
    display: flex;
    background-color: var(--white);
    overflow: hidden;
    flex-direction: column;
    flex-wrap: nowrap;
    height: fit-content;
    align-items: flex-start;
    justify-content: space-between;
    box-shadow: 0px 2px 2.97px 0.03px var(--boxShadow);
`;

export const SectionContainer = styled.div`
    border-radius: 2px;
    border: 1px solid var(--lightBlue);
    padding: 15px 20px 20px;
    border-radius: 2px;
    display: flex;
    background-color: var(--white);
    overflow: hidden;
    flex-direction: column;
    flex-wrap: nowrap;
    height: fit-content;
    align-items: flex-start;
    justify-content: space-between;
    box-shadow: 0px 2px 2.97px 0.03px var(--boxShadow);
`;



// Button styles
export const ButtonPrimary = styled.button`
    background-color: var(--button-color);
    border: 1px solid var(--button-color);
    color: var(--white);
    padding: 6px 15px;
    border-radius: 2px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 34px;
    width: 100%;
    :hover{
       background-color: var(--button-hover-color);
       border: 1px solid var(--button-hover-color);
     }
`;

export const ButtonSecondary = styled.button`
    background-color: #06172a;
    border: 1px solid #06172a;
    color: var(--white);
    padding: 6px 15px;
    border-radius: 2px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 34px;
    width: 100%;
    :hover{
       background-color: var(--button-hover-color);
       border: 1px solid var(--button-hover-color);
     }
`;

export const ButtonDoneEditing = styled.button`
    background-color: var(--button-color);
    border: 1px solid var(--button-color);
    color: var(--white);
    padding: 6px 15px;
    border-radius: 2px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 34px;
    width: 100%;
    :hover{
        background-color: var(--button-hover-color);
        border: 1px solid var(--button-hover-color);
     }
    :disabled {
        background-color: var(--scrollColor);
        border: 1px solid var(--scrollColor);
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

export const DeleteButton = styled.button`
    min-width: 30px;
    width: 30px;
    height: 30px;
    max-height: 30px;
    border-radius: 50%;
    padding: 0;
    display: inline-flex;s
    align-items: center;
    justify-content: center;
    overflow: hidden;
    font-size: 14px;
    box-shadow: 0px 1.5px 2px 0px rgb(0 0 0 / 30%) !important;
    border: none !important;
    background-color:#dc3545;
    color: var(--white);
    
    &:hover {
        background-color: var(--button-hover-color) !important;
    }
    
    i {
        margin-right: 0;
    }
`;

